import React, {useContext, useEffect, useLayoutEffect, useState} from "react";
import {Platform, ScrollView} from "react-native";
import NewHeader from "../components/NewHeader";
import MainStyle from "../../MainStyle";
import P from "../lib/P";
import {colors} from "../assets/styles/colors";
import moment from "moment";
import Div from "../lib/Div";
import {
  ListTournamentRequest_Sort, ListTournamentRequest_TournamentAccess,
  Tournament, TournamentPlayerBet_State, TournamentState, User,
} from "../../generated/smg_service_pb";
import {useIsFocused, useNavigation, useRoute} from "@react-navigation/native";
import Button from "../components/Button";
import BottomNavigation from "../components/BottomNavigation";
import ServiceClient from "../utils/ServiceClient";
import {CancelModalProps} from "../types";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {isFullSwing, LANDING_PAGE_URL, SESSION_EXPIRE_TIME} from "../constants";
import {StoreContext} from "../components/StoreContextProvider";
import useIdleLogout from "../hooks/useIdleLogout";
import {formatCurrency, formatPayout} from "../utils";
import FSHeader from "../components/FSHeader";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import Btn from "../components/Btn";
import {NativeStackNavigationProp} from "@react-navigation/native-stack";

const Sort = ListTournamentRequest_Sort;
const TournamentAccess = ListTournamentRequest_TournamentAccess;

const AllTournaments = () => {
  const [tournamentsList, setTournamentsList] = useState<Tournament[]>([]);
  const navigation: NativeStackNavigationProp<any> = useNavigation();
  const Context = useContext(StoreContext);
  const {cancelModalConfig, user, session} = Context;
  const isFocused = useIsFocused();
  const route = useRoute();
  const params: any = route?.params;
  const onlyCompleted = typeof params?.onlyCompleted === 'string' ? params?.onlyCompleted === 'true' : !!params?.onlyCompleted;

  const listTournaments = () => {
    const states = onlyCompleted ? [TournamentState.FINISHED, TournamentState.VOIDED, TournamentState.CANCELLED] : [];
    const sort = onlyCompleted ? Sort.FINISH_TIME : Sort.DEFAULT;

    ServiceClient.listTournaments(states, sort, [TournamentAccess.PUBLIC, TournamentAccess.PRIVATE], true, false).then(res => {
      Context.setLoadingOverlay(false);

      const tournaments = res.filter(el => {
        const currentNumberOfShots = el?.currentPlayerDetails?.bets.filter(bet => bet.state === TournamentPlayerBet_State.FINISHED && bet.resolved).length || 0;
        return el.state === TournamentState.PLAYING ? currentNumberOfShots === el.totalShots : true;

      }).sort((a, b) => {
        if (a.entryEndDate > b.entryEndDate) return -1;
        if (a.entryEndDate < b.entryEndDate) return 1;
        return 0;
      });

      setTournamentsList(tournaments);

    }).catch(err => {
      console.log('listTournaments err', err);
      Context.setLoadingOverlay(false);

      let conf: CancelModalProps = {
        visible: true, title: 'ERROR', leftBtnText: 'OK', subtitle: err.message,
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
          if (err.code !== 20020042) navigation.navigate({name: 'account', params: {step: 1}});
        }
      };

      Context.setCancelModalConfig(conf);
    });
  };

  const getUser = () => {
    Context.getUser().catch(err => {
      console.log('getUser err', err);
      setTimeout(() => {
        getUser();
      }, 5000);
    });
  };

  useEffect(() => {
    if (!user || !isFocused) return;

    listTournaments();

    const time = setTimeout(() => {
      getUser();
    }, 1000 * 10);

    return () => {
      clearTimeout(time);
    };
  }, [user, isFocused]);

  useIdleLogout({enabled: isFocused, onLogout: () => Context.setLoadingOverlay(false)});

  useLayoutEffect(() => {
    Context.setLoadingOverlay(true);

    if (!session || !user) {
      (async () => {
        const time = await AsyncStorage.getItem('lastActiveTime');

        if (time && moment().diff(moment(time), 'minutes') > SESSION_EXPIRE_TIME) {
          Context.logout().then(() => {
            if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
            Context.setLoadingOverlay(false);
          });

        } else {
          const val = await AsyncStorage.getItem('session');
          let curUser: User | undefined;

          if (val) {
            const Session = JSON.parse(val);
            Context.setSession(Session);

            try {
              curUser = await Context.getUser(Session);

            } catch (e: any) {
              Context.setCancelModalConfig({
                visible: true, title: 'Error', subtitle: e?.message || 'Error', rightBtnText: 'OK',
                onResume: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false})
              });
            }
          }

          if (!val || !curUser || !curUser.userId) {
            Context.logout().then(() => {
              if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
              Context.setLoadingOverlay(false);
            });

          } else console.log('user', curUser);
        }
      })();
    }
  }, []);

  return (
    <>
      {isFullSwing ? (
        <>
          <FSHeader px={20}/>

          <Div h={2} bg="#252526"/>

          <Div gap={5} py={10} px={20}>
            <Div row alignItems="center">
              <Div w={24} alignItems="center"><FontAwesome name="user-circle" size={24} color="#3399FF"/></Div>
              <P fontFamily="DavisSans-Regular" ml={6}>{user?.username}</P>
            </Div>
          </Div>

          <Div h={2} bg="#252526"/>
        </>
      ) : <NewHeader/>}

      <ScrollView contentContainerStyle={MainStyle.flex1} scrollEventThrottle={16}>
        {!isFullSwing && <P fw={500} fs={30} ml={21} mb={1}>Tournaments</P>}

        <Div row justifyContent="space-between" mb={11} mt={isFullSwing ? 11 : 0} alignItems="stretch">
          <P fw={500} fs={22} ml={21}>{!isFullSwing && '/'} {onlyCompleted ? 'Completed' : 'All'} Tournaments</P>
        </Div>

        {!isFullSwing && <Div h={1} bg={colors.divider_bg} mx={22} mb={10}/>}

        {tournamentsList.map(el => (
          <Btn key={el.id} w={360} h={160} rounded={isFullSwing ? 2 : 20} borderWidth={1} mx="auto" mb={10}
               borderColor={colors.settings_border} bg={isFullSwing ? '#252526' : colors.newDarkBlue} pt={10} px={10}
               onPress={() => navigation.navigate('TournamentDetails', {id: el.id, isPrivateTournament: el.isPrivate})}>
            <P color={isFullSwing ? 'white' : colors.id_text} ta="center" fw={500} fs={20} mb={16}>{el.name}</P>

            <Div row>
              <P flex={1} ta="center" fw={500} fs={14} tt="uppercase">Players</P>
              <P flex={1} ta="center" fw={500} fs={14} tt="uppercase">Registered</P>
              <P flex={1} ta="center" fw={500} fs={14} tt="uppercase">Entry Fee</P>
              <P flex={1} ta="center" fw={500} fs={14} tt="uppercase">SHOTS</P>
            </Div>

            <Div row mb={13}>
              <P flex={1} ta="center" fw={700}>1 - {el.maxParticipants}</P>
              <P flex={1} ta="center" fw={700}>{el.playerDetails.length}</P>
              <P flex={1} ta="center" fw={700}>{formatCurrency(el.entryFee / 100)}</P>
              <P flex={1} ta="center" fw={700}>{el.totalShots}</P>
            </Div>

            <Div row justifyContent="space-between">
              <Div ml={12}>
                <P tt="uppercase" fw={500} fs={14} mb={3}>Start</P>
                <P tt="uppercase" fw={500} fs={14}>End</P>
              </Div>

              <Div>
                <P fs={14} fw="700" mb={3}>{moment.unix(Number(el.entryBeginDate)).format('llll')}</P>
                <P fs={14} fw="700">{moment.unix(Number(el.entryEndDate)).format('llll')}</P>
              </Div>

              <Div w={84}>
                <P ta="center" fw={500} fs={14}>PAYOUT</P>
                <P ta="center" fw={700} color={isFullSwing ? '#0AF' : colors.newGreenText}>
                  {el.currentPlayerDetails?.prize ? formatPayout(el.currentPlayerDetails.prize / 100) : 0}
                </P>
              </Div>
            </Div>
          </Btn>
        ))}
      </ScrollView>

      {!isFullSwing && <Div h={1} bg={colors.divider_bg} mx={23} mb={18}/>}

      <Button
        text={isFullSwing ? '< BACK TO TOURNAMENTS' : 'OK'} w={350} mx="auto" fontWeight="600" my={13}
        radius={isFullSwing ? 4 : undefined} bg={isFullSwing ? 'transparent' : undefined}
        color={isFullSwing ? '#007BC1' : undefined}
        onPress={() => navigation.reset({index: 0, routes: [{name: 'tournaments'}]})}
      />

      <P ta="center" fw={500} mb={20} color={colors.gray}>Malfunction voids all pays and plays</P>

      {!isFullSwing && <BottomNavigation page="tournaments"/>}
    </>
  );
};

export default AllTournaments;
